import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { CreateGcrBody, GcrUploadUrlData } from '../types';

export function useCreateGcrs() {
  const {
    isFetching,
    data: uploadUrlData,
    refetch: refetchUploadUrl,
  } = useApiQuery<GcrUploadUrlData>('/gcrs/upload-url', {
    queryKey: ['gcrsUploadUrl'],
    initialData: null,
  });

  const createGcrMutation = useApiMutation<CreateGcrBody>(
    '/gcrs',
    {
      method: 'POST',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    isFetching,
    uploadUrlData,
    refetchUploadUrl,
    createGcrMutation,
  } as const;
}
